import * as Types from "./types";

export const GOOGLE_API_KEY = "AIzaSyDcl7niCiHaGb5HZz39XmljpTTpbdk9fkM";

export const INITIAL_VALUES: Types.StreetAddressResult = {
  countryId: null,
  streetTypeId: null,
  unitNumber: "",
  streetNumber: "",
  streetName: "",
  state: "",
  suburb: "",
  postcode: "",
};
